import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function HotCategories() {
  const displayCategories = categories.filter(c => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热门分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按兴趣探索你最爱的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-200 group-hover:text-accent-700 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count} 篇</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}